import { createSheetService } from './sheetServiceFactory';

const service = createSheetService('Flags', [
  'id',
  'case_id',
  'member_id',
  'reason',
  'status',
  'created_at',
  'updated_at'
]);

export const listFlags = service.list;
export const createFlag = service.create;
export const updateFlag = service.update;
export const deleteFlag = service.remove;